module.exports = __webpack_public_path__ + "static/media/prostitutionArticle3.7842c520.jpg";